import React from 'react';
import Create from 'containers/rest/Create';
import Form from '../components/Form';

const CustomersCreate = (props) => (
  <Create {...props} resource="customers">
    <Form />
  </Create>
);

export default CustomersCreate;
